import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _en = {
    typicalWeek: "Schedule",
    exceptions: "Exceptions"
};

export type I18nCalendarDisplay = typeof _en;

const _fr: I18nCalendarDisplay = {
    typicalWeek: "Horaires",
    exceptions: "Exceptions"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nCalendarDisplay {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}